import React, { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "https://api.nycmanufacturing.com";

export default function LoginPage({ onLogin }) {
  const [empId, setEmpId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    fetch(`${API_URL}/api/employees/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ empId, password }),
    })
      .then((r) => r.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          onLogin(data.employee);
        } else {
          setError(data.error || "Invalid credentials");
        }
      })
      .catch(() => {
        setLoading(false);
        setError("Connection error. Please try again.");
      });
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#F4F2EC",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'Archivo', sans-serif", padding: 20,
    }}>
      <div style={{
        width: "100%", maxWidth: 400,
        background: "#FFFFFF", border: "2px solid #0A0A0F",
        borderRadius: 0, padding: "48px 36px", textAlign: "center",
      }}>
        <div style={{ marginBottom: 32 }}>
          <h1 style={{
            fontSize: 32, fontWeight: 700, lineHeight: 1.2,
            background: "#0033FF",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
            marginBottom: 6,
          }}>
            NYC<br />Manufacturing
          </h1>
          <p style={{ fontSize: 13, color: "rgba(10,10,15,0.58)", letterSpacing: 0.5 }}>Management Platform</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16, textAlign: "left" }}>
            <label style={{ display: "block", fontSize: 14, fontWeight: 500, color: "rgba(10,10,15,0.58)", marginBottom: 6 }}>Employee ID</label>
            <input type="text" value={empId} onChange={(e) => setEmpId(e.target.value)} placeholder="Enter your ID (e.g. 01)" autoComplete="username"
              style={{ width: "100%", padding: "12px 14px", borderRadius: 0, border: "2px solid #0A0A0F", background: "#FFFFFF", color: "#0A0A0F", fontSize: 16, fontFamily: "'Archivo', sans-serif", outline: "none" }}
              onFocus={(e) => (e.target.style.borderColor = "#0033FF")} onBlur={(e) => (e.target.style.borderColor = "#0A0A0F")} />
          </div>
          <div style={{ marginBottom: 24, textAlign: "left" }}>
            <label style={{ display: "block", fontSize: 14, fontWeight: 500, color: "rgba(10,10,15,0.58)", marginBottom: 6 }}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" autoComplete="current-password"
              style={{ width: "100%", padding: "12px 14px", borderRadius: 0, border: "2px solid #0A0A0F", background: "#FFFFFF", color: "#0A0A0F", fontSize: 16, fontFamily: "'Archivo', sans-serif", outline: "none" }}
              onFocus={(e) => (e.target.style.borderColor = "#0033FF")} onBlur={(e) => (e.target.style.borderColor = "#0A0A0F")} />
          </div>

          {error && <div style={{ fontSize: 14, color: "#ef4444", marginBottom: 16 }}>{error}</div>}

          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "14px 20px", borderRadius: 0, border: "none",
            background: "#0033FF", color: "#FFFFFF",
            fontSize: 16, fontWeight: 700, cursor: loading ? "default" : "pointer",
            fontFamily: "'Archivo', sans-serif", opacity: loading ? 0.7 : 1,
          }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p style={{ fontSize: 11, color: "rgba(10,10,15,0.45)", marginTop: 32 }}>NYC Manufacturing — Since 2018</p>
      </div>
    </div>
  );
}
